module.exports = __webpack_public_path__ + "./fonts/GalanoGrotesque-SemiBold.ttf";